import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, RendererFactory2 } from '@angular/core';
import map from 'lodash-es/map';
import { NDfs } from '../dfs.interfaces';

@Injectable({
    providedIn: 'root'
})
export class DfsCssService {
    /**
     * List of existing classes
     */
    private existingClasses: { [classname: string]: number } = {};

    /**
     * List of variables
     */
    private variables: { [scope: string]: { [varName: string]: string } } = {};

    private rulesLength = 0;
    /**
     * Style HTML element
     */
    private styleClasses: HTMLStyleElement;
    private styleVars: HTMLStyleElement;

    constructor(@Inject(DOCUMENT) document: Document, rendererFactory: RendererFactory2) {
        const renderer = rendererFactory.createRenderer(null, null);
        // Create the <style> tag
        this.styleVars = renderer.createElement('style');
        renderer.setAttribute(this.styleVars, 'id', 'dfsStyleVars');
        this.styleClasses = renderer.createElement('style');
        renderer.setAttribute(this.styleClasses, 'id', 'dfsStyle');
        // WebKit hack
        renderer.appendChild(this.styleVars, document.createTextNode(''));
        renderer.appendChild(this.styleClasses, document.createTextNode(''));
        // Add the <style> element to the page
        renderer.appendChild(document.head, this.styleVars);
        renderer.appendChild(document.head, this.styleClasses);
    }

    /**
     * Converts styles to class
     */
    toClass(property: string, value: string, styles: NDfs.ICssEntry[]): string {
        const className = this.getClassName(property, value);
        if (!this.existingClasses[className]) {
            this.addClass(className, styles);
        }
        return className;
    }

    /**
     * Sets variable
     * @param name
     * @param value
     */
    setVariable(scope: string, name: string, value: string, autoApply = true) {
        if (!this.variables[scope]) {
            this.variables[scope] = {};
        }
        this.variables[scope][name] = value;

        if (autoApply) {
            this.applyVariableChanges();
        }
    }

    applyVariableChanges() {
        this.setVariableStyle();
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    private setVariableStyle() {
        this.styleVars.innerHTML = map(
            this.variables,
            (scopeVars, scope) =>
                `[${this.getScopeAttr(scope)}]{\n${map(scopeVars, (value, name) => [name, value].join(':')).join(`;\n`)}\n}`
        ).join(`\n`);
    }

    getScopeAttr(scope: string): string {
        return `_dfs_${scope}`;
    }

    /**
     * Generates class name for dfs entry
     */
    private getClassName(property: string, value: string): string {
        // return `dfs-${property}-${value}`.replaceAll('%', 'p').replaceAll('+', '_');
        return `dfs-${property}-${value}`.replace('%', 'p').replace('+', '_');
    }

    /**
     * Add css class
     */
    private addClass(className: string, styles: NDfs.ICssEntry[]) {
        this.styleClasses.sheet!.insertRule(
            `.${className}{${styles.map(style => `${style.prop}:${style.value};`).join('')}}`,
            this.rulesLength++
        );
        this.styleClasses.innerHTML += `.${className}{${styles.map(style => `${style.prop}:${style.value};`).join('')}}\n`;
        this.existingClasses[className] = 1;
    }
}
